import React from 'react'
import { Typography, Divider, Grid } from '@material-ui/core'
import { useStyles } from './styles'
import { useSelector } from 'react-redux'
import { RootState } from 'src/lib/store'
import { Attachment } from 'src/lib/types'

export const AgentInfo: React.FC = () => {
  const classes = useStyles()
  const payloadState = useSelector((state: RootState) => state.payload.data)

  return (
    <>
      <Typography variant="h6" className={classes.subTitle}>
        Agent Information
      </Typography>
      <Divider />
      <Grid container className={classes.infoGroup}>
        <Grid item xs={6} className={classes.row}>
          <Typography>Name:</Typography>
        </Grid>
        <Grid item xs={6} className={classes.row}>
          <Typography>
            {payloadState.agentFirstName} {payloadState.agentMiddleName ?? payloadState.agentMiddleName} {payloadState.agentLastName} {payloadState.agentSuffix ?? payloadState.agentSuffix}
          </Typography>
        </Grid>
        <Grid item xs={6} className={classes.row}>
          <Typography>Address:</Typography>
        </Grid>
        <Grid item xs={6} className={classes.row}>
          <Typography>
            {payloadState.agentStreetAddress}
            <br />
            {payloadState.agentAddressLine2 !== undefined ? <>{`${payloadState.agentAddressLine2}`} <br /></> : null}
            {payloadState.agentCity} {payloadState.agentState} {payloadState.agentZip}
            <br />
          </Typography>
        </Grid>
        { payloadState.agentEmail && 
        <>
          <Grid item xs={6} className={classes.row}>
            <Typography>Email Address:</Typography>
          </Grid>
          <Grid item xs={6} className={classes.row}>
            <Typography>{payloadState.agentEmail}</Typography>
          </Grid>
        </>
        }
        <Grid item xs={6} className={classes.row}>
          <Typography>Phone Number:</Typography>
        </Grid>
        <Grid item xs={6} className={classes.row}>
          <Typography>{payloadState.agentPhoneNumber}</Typography>
        </Grid>
        <Grid item xs={6} className={classes.row}>
          <Typography>Date of Birth:</Typography>
        </Grid>
        <Grid item xs={6} className={classes.row}>
          <Typography>{payloadState.agentDateOfBirth}</Typography>
        </Grid>
        {payloadState.formAttachments && payloadState.formAttachments.length > 0 && (
          <>
            <Grid item xs={6} className={classes.row}>
              <Typography>Documents:</Typography>
            </Grid>
            <Grid item xs={6} className={classes.row}>
              {payloadState.formAttachments?.map((document: Attachment, i: number) => (
                <div key={document.name+i}>
                  <Typography className={classes.docName}>{document.name}</Typography>
                  <br />
                </div>
              ))}
            </Grid>
          </>
        )}
      </Grid>
    </>
  )
}
